import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "@/store/store";
import "./assets/style/app.scss";
import VueAutosize from "vue-autosize";
import axios from "axios";
// import "@/assets/js/maiiconnect";

Vue.use(VueAutosize);

Vue.config.productionTip = false;

Vue.filter("verifyEmail", async email => {
  if (
    process.env.NODE_ENV === "production" &&
    process.env.VUE_APP_SERVER !== "test"
  ) {
    let result = await axios({
      method: "get",
      url: "https://api.usebouncer.com/v1/email/verify",
      headers: { "X-API-KEY": "LB5Mvl0Xefy6uFhBhFGTVtiz6JA66e15Q2DWS5Jk" },
      params: { email: email }
    });
    return result.data.status === "deliverable";
  } else {
    return true;
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
